import Select from "react-select";
import AsyncSelect from "react-select/async";
import {FormControl, FormLabel, FormErrorMessage} from "@chakra-ui/react";

export const SearchableSelect = ({
  label,
  placeholder,
  options = [],
  isDisabled,
  error,
  touched,
  onChange,
  value,
  color = "gray.400",
  fontWeight = "normal",
  formatOptionLabel,
  async = false,
  defaultOptions = [],
  loadOptions,
  isRequired = true,
  maxHeight = "300px",
  borderRadius = "0",
  menuPlacement = "auto",
  fontSize = "md",
  border = "none",
  minHeight = "",
  my = "2",
  mb = "0",
}) => {
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: minHeight || "32px",
      height: minHeight || "32px",
      border: border !== "none" ? border : state.isFocused ? "1px solid #718096" : "1px solid #E2E8F0",
      borderRadius: borderRadius !== "0" ? borderRadius : "6px",
      boxShadow: state.isFocused ? "0 0 0 1px rgba(55, 65, 81, 0.1)" : "none",
      backgroundColor: "#FFFFFF",
      fontSize: fontSize === "md" ? "13px" : fontSize,
      "&:hover": {
        borderColor: "#CBD5E0",
      },
      transition: "all 0.2s ease",
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: "30px",
      padding: "0 8px",
    }),
    input: (provided) => ({
      ...provided,
      margin: "0",
      padding: "0",
      fontSize: fontSize === "md" ? "13px" : fontSize,
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "30px",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "4px",
      color: "#718096",
      "&:hover": {
        color: "#4A5568",
      },
    }),
    clearIndicator: (provided) => ({
      ...provided,
      padding: "4px",
      color: "#718096",
      "&:hover": {
        color: "#4A5568",
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#000000",
      fontSize: fontSize === "md" ? "13px" : fontSize,
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#2D3748",
      fontSize: fontSize === "md" ? "13px" : fontSize,
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "6px",
      boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
      border: "1px solid #E2E8F0",
      marginTop: "4px",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: maxHeight || "200px",
      overflowY: "auto",
      padding: "4px",
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: fontSize === "md" ? "13px" : fontSize,
      padding: "6px 12px",
      backgroundColor: state.isSelected ? "#E2E8F0" : state.isFocused ? "#F7FAFC" : "transparent",
      color: state.isSelected ? "#2D3748" : "#4A5568",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "#F7FAFC",
      },
      borderRadius: "4px",
      margin: "2px 0",
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontSize: "11px",
      fontWeight: "600",
      color: "#718096",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      padding: "6px 12px",
      margin: "0",
    }),
  };

  const SelectComponent = async ? AsyncSelect : Select;
  let groupedOptions = options || [];
  if (groupedOptions[0]?.options) {
    groupedOptions = groupedOptions.flatMap((option) => option.options);
  }

  return (
    <FormControl
      isInvalid={error && touched}
      my={my}
      isRequired={isRequired}
      zIndex="max"
    >
      <FormLabel
        color={color}
        mb={mb}
        fontWeight={fontWeight}
        fontSize={fontSize}
      >
        {label}
      </FormLabel>
      <SelectComponent
        menuPlacement={menuPlacement}
        cacheOptions={async}
        defaultOptions={async ? defaultOptions : undefined}
        loadOptions={async ? loadOptions : undefined}
        options={!async ? options : undefined}
        onChange={onChange}
        isDisabled={isDisabled}
        placeholder={placeholder}
        styles={customStyles}
        value={
          async
            ? value
              ? defaultOptions.find((option) => option.phid === value)
              : null
            : groupedOptions.find((option) => option.value === value)
        }
        formatOptionLabel={formatOptionLabel}
      />
      <FormErrorMessage>{error}</FormErrorMessage>
    </FormControl>
  );
};
